/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { distritoActivosGet } from '../fn/district/distrito-activos-get';
import { DistritoActivosGet$Params } from '../fn/district/distrito-activos-get';
import { distritoGet } from '../fn/district/distrito-get';
import { DistritoGet$Params } from '../fn/district/distrito-get';
import { distritoIdDistrictGet } from '../fn/district/distrito-id-district-get';
import { DistritoIdDistrictGet$Params } from '../fn/district/distrito-id-district-get';
import { distritoProvinciaIdProvinceGet } from '../fn/district/distrito-provincia-id-province-get';
import { DistritoProvinciaIdProvinceGet$Params } from '../fn/district/distrito-provincia-id-province-get';

@Injectable({ providedIn: 'root' })
export class DistrictService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `distritoGet()` */
  static readonly DistritoGetPath = '/distrito';

  /**
   * getAll.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `distritoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  distritoGet$Response(params?: DistritoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return distritoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAll.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `distritoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  distritoGet(params?: DistritoGet$Params, context?: HttpContext): Observable<any> {
    return this.distritoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `distritoActivosGet()` */
  static readonly DistritoActivosGetPath = '/distrito/activos';

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `distritoActivosGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  distritoActivosGet$Response(params?: DistritoActivosGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return distritoActivosGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `distritoActivosGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  distritoActivosGet(params?: DistritoActivosGet$Params, context?: HttpContext): Observable<any> {
    return this.distritoActivosGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `distritoIdDistrictGet()` */
  static readonly DistritoIdDistrictGetPath = '/distrito/{idDistrict}';

  /**
   * getById.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `distritoIdDistrictGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  distritoIdDistrictGet$Response(params: DistritoIdDistrictGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return distritoIdDistrictGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getById.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `distritoIdDistrictGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  distritoIdDistrictGet(params: DistritoIdDistrictGet$Params, context?: HttpContext): Observable<any> {
    return this.distritoIdDistrictGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `distritoProvinciaIdProvinceGet()` */
  static readonly DistritoProvinciaIdProvinceGetPath = '/distrito/provincia/{idProvince}';

  /**
   * getByProvince.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `distritoProvinciaIdProvinceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  distritoProvinciaIdProvinceGet$Response(params: DistritoProvinciaIdProvinceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return distritoProvinciaIdProvinceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getByProvince.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `distritoProvinciaIdProvinceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  distritoProvinciaIdProvinceGet(params: DistritoProvinciaIdProvinceGet$Params, context?: HttpContext): Observable<any> {
    return this.distritoProvinciaIdProvinceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
